module.exports = __webpack_public_path__ + "static/media/home-lg.d2aa46af.svg";